<div class="action-board my-3">
  <h4 class="action-board__title">{{ title }}</h4>

  <div class="action-board__strip hide-scrollbar">
    <!-- The card itself is inert: only the corner icon navigates. -->
    <div *ngFor="let item of items" class="action-board__card">
      <span class="action-board__name">{{ item.name }}</span>

      <span class="action-board__value-row">
        <mat-icon
          class="action-board__icon"
          [svgIcon]="item.icon"
        ></mat-icon>

        <span
          *ngIf="item.isFetching"
          class="action-board__skeleton"
          aria-hidden="true"
        ></span>

        <span *ngIf="!item.isFetching" class="action-board__value">{{
          item.value !== null ? (item.value | number) : "—"
        }}</span>
      </span>

      <a
        class="action-board__open-link"
        [routerLink]="item.route"
        [queryParams]="item.queryParams"
        [attr.aria-label]="item.openLabel"
        [matTooltip]="item.openLabel"
      >
        <mat-icon
          class="action-board__open"
          svgIcon="action_board_open"
        ></mat-icon>
      </a>
    </div>
  </div>
</div>
